'use strict';

var Promise = require('bluebird');
var imageReader = require('./imageReader');
require('../components/checkbox');
require('./imagePreview');

var $pdfEditorContainer = $('.js-pdf-editor-container');
var $mobileLanguageSelector = $pdfEditorContainer.find('.js-mobile-language-selection');
var $editModal = $pdfEditorContainer.find('.edit-modal');
var $summernote = $editModal.find('.js-summernote');
var $saveButtons = $pdfEditorContainer.find('.js-pdf-template-btn-save');
var $resetButtons = $pdfEditorContainer.find('.js-btn-reset');
var $forms = $pdfEditorContainer.find('form');
var originalData = $forms.toArray().map(function (form) {
  return $(form).serializeArray();
});

$mobileLanguageSelector.click(function (e) {
  var $this = $(this);
  var target = $this.attr('data-target');
  $(target).tab('show');
});

$summernote.summernote({
  height: '300px',
  toolbar: [
    ['style', ['bold', 'italic', 'underline', 'clear']],
    ['para', ['ul', 'ol']],
    ['insert', ['link']]
  ],
  placeholder: 'placeholder'
});

function getInput ($button) {
  var $form = $button.parents('form');
  var inputTargetName = $button.attr('data-input');
  return $form.find('input[name="' + inputTargetName + '"]');
}

$editModal.on('shown.bs.modal', function (event) {
  var $this = $(this);

  var $button = $(event.relatedTarget);

  var $input = getInput($(event.relatedTarget));
  $this.data('relatedTarget', event.relatedTarget);

  var $summernote = $this.find('.js-summernote');
  $summernote.code($input.val());

  // Override the placeholder
  var placeholder = $button.attr('data-placeholder') || '';
  $('.note-editable').attr('data-placeholder', placeholder);
});

$editModal.find('.js-btn-done').click(function (event) {
  var $this = $(this);
  var relatedTarget = $this.parents('.modal').data('relatedTarget');
  var $input = getInput($(relatedTarget));
  var code = $summernote.code();

  // Update the input linked to this modal
  $input.val(code);

  // Update the preview box
  var $preview = $input.siblings('.js-text-preview');
  $preview.text(code);
  $preview.html($preview.text().substr(0, 64) + '...');
});

function filterNotChanged (base, data) {
  var requiredFields = [
    'company-descr', 'company-ending', 'custom-color', 'footer-text',
    'language', 'active-scoring', 'active-ending', 'remove-links',
    'print-format', 'id', 'langCode'
  ];

  for (var i = 0; i < data.length; i++) {
    var baseEntry = base[i];
    var entry = data[i];
    if (requiredFields.indexOf(entry.name) !== -1) {
      continue;
    } else if (baseEntry.name === entry.name && baseEntry.value === entry.value) {
      delete data[i];
    }
  }
  return data;
}

function saveForm (formIndex) {
  var base = originalData[formIndex];
  var data = $($forms[formIndex]).serializeArray();
  data = filterNotChanged(base, data);

  return Promise.resolve($.post('/en/template/edit', data))
  .then(function (result) {
    if (!result.success) {
      throw new Error('Saving template data failed');
    }
  });
}

function saveFormLogoAndSignature (formIndex) {
  var $form = $($forms[formIndex]);
  var $imageInputs = $form.find('.js-image-input-file');

  return Promise.all($imageInputs.map(function (index, imageInput) {
    var file = imageInput.files[0];
    return imageReader.readAsBase64(file)
    .then(function (data) {
      if (!data) {
        return null;
      }

      var $imageInput = $(imageInput);
      var postData = {
        logoType: $imageInput.attr('data-logo-type'),
        logoData: data
      };

      var templateId = $form.find('input[name=id]').val();
      var templateLang = $form.find('input[name=langCode]').val();

      if (templateId) {
        postData.templateId = templateId;
      } else if (templateLang) {
        postData.templateLang = templateLang;
      }

      return $.post('/en/template/editLogo', postData)
      .then(function (result) {
        if (!result.success) {
          throw new Error('Saving template logo failed');
        }
      });
    });
  }).toArray());
}

function saveForms () {
  return Promise.all(
    $forms.map(function (index) {
      return saveForm(index)
      .then(function () {
        return saveFormLogoAndSignature(index);
      });
    }
  ).toArray());
}

$saveButtons.click(function (event) {
  $saveButtons.removeClass('success');
  $saveButtons.removeClass('error');
  $saveButtons.addClass('busy');
  saveForms()
  .then(function (results) {
    $saveButtons.addClass('success');
  })
  .catch(function () {
    $saveButtons.addClass('error');
  })
  .finally(function () {
    $saveButtons.removeClass('busy');
  });
});

$resetButtons.click(function (event) {
  var $this = $(this);
  var $form = $this.parents('form');
  var $input = $this.siblings('label').find('input');
  var data = {
    userId: String(window.wooGlobal.user.id),
    logoType: $input.attr('data-logo-type'),
    logoData: ''
  };

  var templateId = $form.find('input[name=id]').val();
  var templateLang = $form.find('input[name=langCode]').val();

  $this.closest('.panel-body').find('img').attr('src', '');
  if (templateId) {
    data.templateId = templateId;
  } else if (templateLang) {
    data.templateLang = templateLang;
  }

  return $.post('/en/template/editLogo', data)
  .then(function (result) {
    if (!result.success) {
      throw new Error('Removing Logo failed');
    }
  });
});
